<template>
  <header class="site-header">
    <div class="header-content">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="安徽省数字文化产业创新研究院" />
      </div>
      <div class="right-section">
        <!-- <a href="#" class="login-btn">登录注册</a>
        <a href="#" class="lang-btn">中文/EN</a> -->
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
};
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 5;
  .header-content {
    width: 1200px;
    margin: 0 auto;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .logo {
      img {
        height: 80px;
      }
    }

    .right-section {
      display: flex;
      gap: 20px;

      a {
        color: #333;
        text-decoration: none;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
</style>
